export const daysOfWeek = [
  { id: 'MON', value: 'Пн' },
  { id: 'TUE', value: 'Вт' },
  { id: 'WEN', value: 'Ср' },
  { id: 'THU', value: 'Чт' },
  { id: 'FRI', value: 'Пт' },
  { id: 'SAT', value: 'Сб' },
  { id: 'SUN', value: 'Вс' },
];

export const months = [
  { id: 'JANUARY', value: 'Январь', short: 'Янв' },
  { id: 'FEBRUARY', value: 'Февраль', short: 'Фев' },
  { id: 'MARCH', value: 'Март', short: 'Мар' },
  { id: 'APRIL', value: 'Апрель', short: 'Апр' },
  { id: 'MAY', value: 'Май', short: 'Май' },
  { id: 'JUNE', value: 'Июнь', short: 'Июнь' },
  { id: 'JULY', value: 'Июль', short: 'Июль' },
  { id: 'AUGUST', value: 'Август', short: 'Авг' },
  { id: 'SEPTEMBER', value: 'Сентябрь', short: 'Сен' },
  { id: 'OCTOBER', value: 'Октябрь', short: 'Окт' },
  { id: 'NOVEMBER', value: 'Ноябрь', short: 'Ноя' },
  { id: 'DECEMBER', value: 'Декабрь', short: 'Дек' },
];

export const moreFunctions = [
  {
    id: '1TH',
    name: 'Первый',
    short: '1-й',
    shortFm: '1-я',
    shortMd: '1-е',
  },
  {
    id: '2TH',
    name: 'Второй',
    short: '2-й',
    shortFm: '2-я',
    shortMd: '2-е',
  },
  {
    id: '3TH',
    name: 'Третий',
    short: '3-й',
    shortFm: '3-я',
    shortMd: '3-е',
  },
  {
    id: '4TH',
    name: 'Четвертый',
    short: '4-й',
    shortFm: '4-я',
    shortMd: '4-е',
  },
  {
    id: '5TH',
    name: 'Пятый',
    short: '5-й',
    shortFm: '5-я',
    shortMd: '5-е',
  },
  {
    id: 'LAST',
    name: 'Последний',
    short: 'Последн',
    shortFm: 'Последн',
    shortMd: 'Последн',
  },
];
